/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodUnamused = createReactComponent("outline", "mood-unamused", "IconMoodUnamused", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11 16l4 -1.5", "key": "svg-1" }], ["path", { "d": "M10 10c-.5 -1 -2.5 -1 -3 0", "key": "svg-2" }], ["path", { "d": "M17 10c-.5 -1 -2.5 -1 -3 0", "key": "svg-3" }]]);

export { IconMoodUnamused as default };
//# sourceMappingURL=IconMoodUnamused.mjs.map
